import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'consts';

import { postBoardQueueGroup } from '../requests';
import type { PostBoardQueueGroupRequest } from '../types';

export const usePostBoardQueueGroup = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: PostBoardQueueGroupRequest) =>
      postBoardQueueGroup(params),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [API_QUERY_KEYS.boardQueueGroups],
      });
    },
  });
};
